












import Vue, { PropOptions } from 'vue';
import { Campaign, CampaignStatus } from '@/models';
import ButtonAction from '@/components/ButtonAction.vue';
import CampaignService from '@/services/CampaignService';
export default Vue.extend({
  components: { ButtonAction },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  computed: {
    isRunning(): boolean {
      return CampaignService.isRunning(this.campaign);
    },
  },
  methods: {
    async pause() {
      try {
        await this.$store.dispatch('updateCampaign', {
          status: CampaignStatus.Paused,
          objectId: this.campaign.objectId,
        });
        this.campaign.status = CampaignStatus.Paused as any;
        this.$store.commit('addSnackbar', {
          text: `Campanha pausada com sucesso`,
          color: 'success',
        });
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao pausar campanha: ${error.message}`,
        });
      }
    },
  },
});
